import React, { useState, useEffect } from "react";
import InValidLottie from "../Lottie-Components/InValidLottie";
import { PAGE_LIMIT } from "../../constants/text_constants";
import CourseCard from "../Card-Component/CourseCard";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { setMyCoursesCache } from "../../configs/cache";
import { useDispatch, useSelector } from "react-redux";
import LoadingLottie from "../Lottie-Components/LoadingLottie";
import { useNavigate } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import IntegratedPagination from "../Pagination/IntegratedPagination";

const MyCoursesList = () => {
  const userAuthenticated = sessionStorage.getItem("authenticated") === "1";
  const [currentPage, setCurrentPage] = useState(0);
  const [myCourses, setMyCourses] = useState(null);
  const cache = useSelector((store) => store.cache.myCoursesCache);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();

const fetchMyCourses = async (retries = 6) => {
  try {
    const authToken = sessionStorage.getItem("token");

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    const response = await fetch(
      process.env.REACT_APP_RANK_PLUS_MY_COURSES_DATA +
        PAGE_LIMIT +
        `/${currentPage}`,
      requestOptions
    );

    if (!response.ok) {
      if (response.status >= 400 && response.status < 500) {
        userLogout(navigate, dispatch, true);
        return;
      }

      if (response.status >= 500 && response.status < 600 && retries > 0) {
        console.warn(
          `Retrying My Courses... attempts left: ${retries}`
        );

        setTimeout(() => {
          fetchMyCourses(retries - 1);
        }, 10000);

        return;
      }

      throw new Error(`HTTP error: ${response.status}`);
    }

    const json = await response.json();

    setMyCourses(json?.data);

    setTotalPages(
      Math.ceil((json?.data?.total || 0) / PAGE_LIMIT)
    );

    dispatch(
      setMyCoursesCache([
        json?.data,
        currentPage,
      ])
    );

  } catch (err) {
    console.error("Error fetchMyCourses:", err);
  }
};

  useEffect(() => {
    if (userAuthenticated) {
      if (cache[currentPage]) {
        setMyCourses(cache[currentPage]);
        setTotalPages(Math.ceil(cache[currentPage]?.total / PAGE_LIMIT));
      } else {
        fetchMyCourses();
      }
    }
  }, [currentPage, cache]);

  // user has not signed in
  if (!userAuthenticated) {
    return <InValidLottie text={"You Need to sign in to see your courses"} />;
  }

  // loading animation
  if (!myCourses) {
    return <LoadingLottie />;
  }

  if (myCourses?.courses?.length === 0) {
    return <InValidLottie text={"You have not purchased any courses"} />;
  }

  return (
    <div>
      <div className=" grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-8 gap-4">
        {myCourses?.courses?.map((ele, i) => (
          <CourseCard
            key={i}
            name={ele?.name}
            offer_price={ele?.offer_price}
            offer_discount={ele?.offer_discount}
            price={ele?.price}
            course_banner={ele?.course_banner}
            title_1={"Duration"}
            value_1={ele?.duration}
            title_2={"Start Date"}
            value_2={ele?.starts_on}
            payment_plans={ele?.payment_plans || []}
            title_3={"End Date"}
            value_3={ele?.ends_on}
            title_4={"Validity"}
            value_4={ele?.validity}
            rating={ele?.rating}
            faculty_name={ele?.faculty_name}
            thumbnail={ele?.faculty_thumbnail}
            description={ele?.description}
            totalRating={ele?.total_rating}
            id={ele?.id}
            exploreMoreLink={UNPROTECTED_ROUTES?.courseDetails}
            showPrice={false}
            showBuyNow={false}
            showExploreMore={false}
            showView={true}
          />
        ))}
      </div>
      <div className="lg:my-[5rem] my-[1rem]">
        <IntegratedPagination
          currentPage={currentPage + 1}
          totalPages={totalPages}
          setCurrentPage={(page) => setCurrentPage(page - 1)}
        />
      </div>
    </div>
  );
};

export default MyCoursesList;
